<template lang="pug">
  .table-responsive
    table#tbStatusTarjeta.table.is-striped.is-fullwidth.is-narrow
      thead
        tr
          th 
            | Usuario
          th 
            | Tarjeta
          th 
            | Cant. Autorizada
          th 
            | Extra
          th 
            | Salidas
          th 
            | Restante
      tbody
        tr(v-for="(t, index) in tarjetas" :key="t.id")
          td
            span.tag.is-dark
              | {{ t.recibe }}
          td
            span.tag.is-light 
              | {{ t.tarjeta }}
          td 
            span.tag.is-light
              | {{ t.asignado }}
          td 
            span.tag.is-light(v-show="t.extra !== '0'")
              | {{ t.extra }}
          td
            span.tag.is-danger
              | {{ t.salidas }}
          td
            span.tag.is-light
              | {{ t.restante }}
</template>

<script>
  export default {
    name: 'TbStatusTarjeta',
    props: {
      tarjetas: {
        type: Array,
        default: []
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/Tb_StatusTarjeta.vue